// @flow
import React, { Component } from 'react';
import ShippingTrackingTemplate from 'components/order/ShippingTrackingTemplate';
import * as OrdersAPI from 'lib/api/me/orders';

type Props = {
  match: {
    params: {
      orderId: string,
      fulfillmentId: string,
    },
  },
  location: {
    search: string,
  },
};

type State = {
  tracking: Array<any>,
  courierName: string,
  invoiceNo: string,
  receiverName: string,
  receiverAddr: string,
  loading: boolean,
  error: ?string,
};

class ShippingTrackingContainer extends Component<Props, State> {
  state = {
    tracking: [],
    courierName: '',
    invoiceNo: '',
    receiverName: '',
    receiverAddr: '',
    loading: true,
    error: null,
  };

  async componentDidMount() {
    await this.loadTrackingData();
  }

  loadTrackingData = async () => {
    const { orderId, fulfillmentId } = this.props.match.params;
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get('token');

    if (!token) {
      this.setState({ error: '잘못된 접근입니다.', loading: false });
      return;
    }

    try {
      const response = await OrdersAPI.getShippingTracking(orderId, fulfillmentId, token);
      if (response.data && response.data.length > 0) {
        const courierCodes = {
          '04': 'CJ대한통운',
          '05': '한진택배',
          '08': '롯데택배',
          '01': '우체국택배',
          '06': '로젠택배',
          '17': '천일택배',
          '22': '대신택배',
          '23': '경동택배',
          '151': '자이언트',
          '74': '용마로지스',
          '24': 'GS Postbox 택배',
          '46': 'CU편의점택배',
          '189': '세븐일레븐 착한택배',
        };

        this.setState({
          tracking: response.data,
          courierName: courierCodes[response.data[0].courier_code] || '택배',
          invoiceNo: response.data[0].invoice_no || '',
          receiverName: response.data[0].recv_name || '',
          receiverAddr: response.data[0].recv_addr || '',
          loading: false,
        });
      } else {
        this.setState({ error: '배송 정보를 찾을 수 없습니다.', loading: false });
      }
    } catch (e) {
      console.error(e);
      this.setState({ error: '배송 정보를 불러오는데 실패했습니다.', loading: false });
    }
  };

  render() {
    const {
      tracking,
      courierName,
      invoiceNo,
      receiverName,
      receiverAddr,
      loading,
      error,
    } = this.state;

    if (loading) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: '#e7f5ff',
          }}
        >
          <div>로딩 중...</div>
        </div>
      );
    }

    if (error) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: '#e7f5ff',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <div style={{ fontSize: '1.25rem', color: '#1971c2' }}>{error}</div>
        </div>
      );
    }

    return (
      <ShippingTrackingTemplate
        tracking={tracking}
        courierName={courierName}
        invoiceNo={invoiceNo}
        receiverName={receiverName}
        receiverAddr={receiverAddr}
      />
    );
  }
}

export default ShippingTrackingContainer;



// WEBPACK FOOTER //
// ./src/containers/ShippingTrackingContainer.js